import moment from "moment-timezone";

const initialState = {
  closeMenu: "",
  logo: "",
  darkMode: false,
  theme: "",
  gettheme: "",
  themecode: "",
  getthemevalue: "",
  showRecording: false,
  omniData: null,
  userInteracted: false,
  audioOutputSelection: {},
  showInvalidAudioSettingsMessage: false
};
export default function (state = initialState, action) {
  switch (action.type) {
    case "CLOSE_MENU_POPUP":
      return {
        ...state,
        closeMenu: action.payload,
      };
    case "SET_LOGO":
      return {
        ...state,
        logo: action.payload,
      };
    case "set_thememode":
      return {
        ...state,
        darkMode: action.payload,
      };
    case "set_theme":
      return {
        ...state,
        theme: action.payload,
      };
    case "get_theme":
      return {
        ...state,
        gettheme: action.payload,
      };
    case "set_themecode":
      return {
        ...state,
        themecode: action.payload,
      };
    case "get_themevalue":
      return {
        ...state,
        getthemevalue: action.payload,
      };
    case "set_showRecording":
      return {
        ...state,
        showRecording: action.payload,
      };
    case "set_omnidata":
      return {
        ...state,
        omniData: action.payload,
      };
    case "set_userInteraction":
      return {
        ...state,
        userInteracted: action.payload,
      };
    case "settings_audio":
      return {
        ...state,
        audioOutputSelection : action.payload
      };
    case "set_showInvalidAudioSettingsMessage":
      return {
        ...state,
        showInvalidAudioSettingsMessage : action.payload
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/common.js